import { mdiInformationOutline, mdiLogoutVariant } from "@mdi/js";
import { List, Space, Tag, Typography } from "antd";
import { useDispatch } from "app/store";
import { MaterialIcon } from "components/MaterialIcon";
import useConfigurationQuery from "hooks/queries/useConfigurationQuery";
import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  SidebarContext,
  SidebarDivider,
  SidebarMenu,
  SideMenuOptionProps,
} from "widgets/layout/sidebar-header-layout";
import styles from "./SidebarFooterMenu.module.scss";
import clsx from "clsx";

const SidebarFooterMenu: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const query = useConfigurationQuery();
  const { open } = useContext(SidebarContext);
  const showNewVersionTag = query.data?.newVersion;

  const footerOptions = useMemo<SideMenuOptionProps[]>(
    () => [
      {
        label: t("menu.logout"),
        icon: <MaterialIcon path={mdiLogoutVariant} />,
        onClick: () => dispatch.auth.logout(),
      },
    ],
    [dispatch.auth, t]
  );

  return (
    <>
      <List className={styles.about}>
        <List.Item
          className={clsx({
            [styles.collapsedMenu]: !open && showNewVersionTag,
          })}
        >
          {((showNewVersionTag && open) || !showNewVersionTag) && (
            <Space onClick={() => dispatch.common.setAboutModalVisible(true)}>
              <MaterialIcon
                path={mdiInformationOutline}
                size={0.75}
                color="white"
              />
              <Typography.Text>{open ? t("menu.about") : ""}</Typography.Text>
            </Space>
          )}
          {showNewVersionTag && (
            <Tag className={styles.newTag}>{t("common.new")}</Tag>
          )}
        </List.Item>
      </List>

      <SidebarDivider />

      <SidebarMenu
        options={footerOptions}
        menuItemClassName={styles.footerMenuItem}
      />
    </>
  );
};

export default SidebarFooterMenu;
